<template>
	<v-container class="pa-0">
		<!-- Seção de vade-mécuns -->
		<v-row class="mb-8" style="background-color: #F2F2F2; border-radius: 4px">
			<v-col cols="12" md="6" class="d-flex align-center mobileAlign">
				<h2 style="
            font-family: Inter;
            font-weight: bold;
            color: #F15A24;
            line-height: 1;
            font-size: 1.5rem;
            margin: 0;
          ">
					<span style="color: #242424;">Seus</span> vade-mécuns
				</h2>

			</v-col>
			<v-col cols="12" md="6" class="d-flex align-center justify-end mobileAlign">
				<v-btn :disabled="user.plano === `plano-free` && vademecum.length >= 1"
					@click="showDialogAddVade = true" large color="#F15A24" dark>
					<v-icon color="white">mdi-plus</v-icon>
					Adicionar vade-mécuns
				</v-btn>
			</v-col>
		</v-row>

		<!-- Grid de vade-mécuns -->
		<v-row class="mb-8">
			<v-col v-for="(v, index) in vademecum" :key="v.id" cols="12" md="6">
				<v-card class="vademecum-card" outlined @click="vademecumSeleceted = { ...v, edit: false }; showDialogVerLeis = true;">
					<v-card-title class="d-flex justify-space-between align-center pa-4">
						<span class="text-h6 font-weight-bold" style="word-break:break-word; max-width: 90%;">
							{{ v.titulo || `Vade-mécum ${index + 1}` }}
							<v-icon :color="v.cor || '#F15A24'" size="20">mdi-circle</v-icon>
						</span>
						<!-- <v-btn icon small @click="excluirVadeMecum(v)" text>
							<v-icon>mdi-delete</v-icon>
						</v-btn> -->

						<v-menu offset-y>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" style="color: #000 !important">
									<v-icon>mdi-dots-vertical</v-icon>
								</v-btn>
							</template>

							<v-list>
								<v-list-item >
									<v-btn  small text @click="excluirVadeMecum(v)">
										<v-icon class="mr-2">mdi-delete</v-icon> Excluir
									</v-btn>
								</v-list-item>
							</v-list>
						</v-menu>

					</v-card-title>

					<v-card-text class="pa-4">
						<div class="mb-3">


							<!-- Mostrar apenas se houver leis -->
							<v-chip v-if="v.leis && v.leis.length > 0" style="border-radius: 4px" color="#F15A24"
								text-color="white" small class="mr-2 mb-2">
								{{ v.leis.length }} {{ v.leis.length === 1 ? 'Lei' : 'Leis' }}
							</v-chip>

							<!-- Contagem projetos de leis -->
							<v-chip v-if="v.projetos_leis && v.projetos_leis.length > 0"
								style="border-radius: 4px" outlined color="#F15A24" small
								class="mr-2 mb-2">
								{{ v.projetos_leis ? v.projetos_leis.length : 0 }}
								Projetos de Lei
							</v-chip>
						</div>
					</v-card-text>

					<!-- Footer do card com status e botão -->
					<v-card-actions class="pa-4"
						style="display: flex; justify-content: space-between; align-items: center;">
						<!-- Status real do vade-mécum -->
						<div class="d-flex align-center">
							<v-icon small class="mr-2">{{v.status === 'public' ? 'mdi-eye' : 'mdi-eye-off'}}</v-icon>
							<span class="">{{ getVadeMecumStatus(v) }}</span>
						</div>

						<!-- Informações adicionais se disponíveis -->
						<v-btn text
							color="#F15A24">
							<v-icon>mdi-book-open-page-variant-outline</v-icon>
							Abrir
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>

		<!-- Vades Mecuns sugeridos -->
			<v-row class="mb-8" style="background-color: #F2F2F2; border-radius: 4px">
			<v-col cols="12" class="d-flex align-center mobileAlign">
				<h2 style="
            font-family: Inter;
            font-weight: bold;
            color: #F15A24;
            line-height: 1;
            font-size: 1.5rem;
            margin: 0;
          ">
					Vade-mécuns <span style="color: #242424;">sugeridos pela </span> mylegis
				</h2>	</v-col>
			</v-row><v-row>
				
			<v-col cols="12" v-if="loadingSuggestedVades" class="d-flex justify-center">
				<v-progress-circular indeterminate color="#F15A24"></v-progress-circular>
			</v-col>
			<template v-else>
				<v-col v-for="(v, idx) in suggestedVademecuns" :key="`sug-${v.id}`" cols="12" md="6">
					<v-card outlined class="vademecum-card" @click="vademecumSeleceted = { ...v, edit: false, locked:true }; showDialogVerLeis = true;">
						<v-card-title class="d-flex justify-space-between align-center pa-4">
							<span class="text-h6 font-weight-bold">{{ v.titulo || `Vade-mécum ${idx + 1}` }}
								<v-icon :color="v.cor || '#F15A24'" size="20">mdi-circle</v-icon>
							</span>
						</v-card-title>
						<v-card-text class="pa-4">
							<v-chip v-if="v.leis && v.leis.length > 0" style="border-radius: 4px" color="#F15A24" text-color="white" small>
								{{ v.leis.length }} {{ v.leis.length === 1 ? 'Lei' : 'Leis' }}
							</v-chip>

							<v-chip v-if="v.projetos_leis && v.projetos_leis.length > 0" style="border-radius: 4px" color="#F15A24" outlined small>
								{{ v.projetos_leis.length }} {{ v.projetos_leis.length === 1 ? 'Projeto Lei' : 'Projetos Lei' }}
							</v-chip>
						</v-card-text>
						<v-card-actions class="pa-4" style="display:flex; justify-content:flex-end;">
							<v-btn text color="#F15A24" >
								<v-icon>mdi-import</v-icon>
								Importar
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</template>
		</v-row>

		<!-- Sugestão -->
		<div>
			<v-row>
				<v-col class="text-center" style="font-size: 18px">
					Não encontrou a lei desejada?
					<v-btn style="font-size: 18px" @click="showDialogSugestao = true" outlined>Clique aqui</v-btn>
					que adicionaremos para você.
				</v-col>
			</v-row>
		</div>

		<!-- Snackbar -->
		<v-snackbar v-model="snack.show">
			{{ snack.text }}
		</v-snackbar>

		<!-- Dialog adicionar novo vade -->
		<!-- <v-dialog width="500px" v-model="showDialogAddVade">
			<v-card>
				<v-card-title>Adicionar um novo vade-mécum</v-card-title>
				<v-card-text>
					<h3>Título</h3>
					<v-text-field color="#F15A24" v-model="newVadeMecum"></v-text-field>
					<h3>Cor</h3>
					<div>
						<v-color-picker class="mx-auto my-2" :swatches="swatches" v-model="newVadeMecumColor"
							hide-inputs show-swatches></v-color-picker>
					</div>
				</v-card-text>
				<v-card-actions class="text-center">
					<v-btn class="mx-auto" color="#F15A24" :loading="loadingNewVade" dark
						@click="postVadeMecum">Adicionar
						Vade-mécum</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog> -->



		<v-dialog v-model="showDialogAddVade" fullscreen>
			<v-card>
				<!-- HEADER -->
				<v-toolbar dark color="grey darken-3" class="elevation-0">
					<v-toolbar-title class="text-h6 font-weight-bold">
						<span class="text-h6">Adicionar um novo vade-mécum</span>
					</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn icon @click="showDialogAddVade = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<v-divider></v-divider>

				<v-card-actions class="" style="width: 100%;">
					<v-row style="background-color: #f8f9fa;">
						<v-col cols="12" md="12" class="d-flex justify-end align-center">
							<v-btn color="#F15A24" dark large :loading="loadingNewVade" @click="postVadeMecum">
								Salvar e finalizar
							</v-btn>
						</v-col>
					</v-row>
				</v-card-actions>



				<!-- MAIN CONTENT -->
				<v-card-text>
					<v-container fluid>
						<v-row>
							<!-- COLUNA ESQUERDA: FORM -->
							<v-col cols="12" md="6">
								<h3 class="mb-2">Título</h3>
								<v-text-field color="#F15A24" v-model="newVadeMecum" label="Seu título aqui"
									counter="30" outlined />
								
								<h3 class="mt-4 mb-2">Cor</h3>
								<v-color-picker class="mx-auto" :swatches="swatches" v-model="newVadeMecumColor"
									hide-inputs show-swatches flat />
							</v-col>
							
							<!-- COLUNA DIREITA: LISTA DE LEGISLAÇÕES -->
							<v-col cols="12" md="6" class="pl-md-6">
								<div class="mt-8">
									<v-text-field v-on:keyup.enter="searchLeisInVadeMecum"
										:disable="loadingInternalSearch" clearable v-model="searchAddLeis"
										@click:clear="clearInternalSearch" @click:append="searchLeisInVadeMecum"
										:append-icon="loadingSearch ? `mdi-loading` : `mdi-magnify`" color="#F15A24"
										hide-details outlined
										placeholder="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
										label="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)" />
								</div>
								<div style="overflow: scroll; max-height: 400px;">
									<v-list class="mt-3">
										<v-list-item-title>
											Legislações sugeridas:
										</v-list-item-title>
										<v-list-item class="px-0 text-center d-flex justify-center"
											v-if="loadingInternalSearch">
											<v-progress-circular indeterminate></v-progress-circular>
										</v-list-item>
										<v-list-item class="px-0 text-center d-flex justify-center"
											v-if="internalLeisSearch.length === 0 && !loadingInternalSearch">
											<p>Nenhuma legislação encontrada, confira os filtros acima.</p>
										</v-list-item>
										<v-hover v-slot="{ hover }" v-for="item in internalLeisSearch"
											:key="item.id_lei">
											<v-list-item :class="hover ? `bkgHover` : ``"
												style="border-top: 1px solid #F15A24; border-radius: 10px"
												class="mb-5"><v-list-item-content>
													<v-row align="center" class="mb-2" no-gutters>
														<v-col class="pa-0">
															<v-list-item-title>
																<span v-html="highlight(item.numero_lei, searchAddLeis)"></span>
															</v-list-item-title>
														</v-col>
														<v-col class="pa-0 mt-1">
															<v-chip class="mr-2" color="#F15A24" outlined
																text-color="#F15A24" style="height: 1.5rem">
																{{ item.esfera_lei }}
															</v-chip>
															<v-chip color="#F15A24" outlined text-color="#F15A24"
																v-if="item.esfera_lei === `Estadual`"
																style="height: 1.5rem">
																{{ item.estado_lei }}
															</v-chip>
															<v-chip class="ml-2" color="#F15A24" outlined
																text-color="#F15A24"
																v-if="item.esfera_lei === `Municipal`"
																style="height: 1.5rem">
																{{ item.municipio_lei }}
															</v-chip>
														</v-col>
													</v-row>
													<div>
														<small v-html="highlight(item.nome_lei, searchAddLeis)"></small>
													</div>
												</v-list-item-content>

												<v-list-item-action class="text-center">
													<span class="text-subtitle"
														style="min-width: 90px; text-transform: uppercase" v-if="
														vademecumSeleceted.leis.find(
															(e) => parseInt(e.leis_id_lei.id_lei) === item.id_lei
														)
													">
														Adicionado
													</span>
													<v-btn v-else small text color="#F15A24" :loading="item.loading"
														@click="idleis.push(item.id_lei)" :disabled="isLeiInVade(item.id_lei, vademecumSeleceted.leis)
															">
														Adicionar
													</v-btn>
												</v-list-item-action>
											</v-list-item>
										</v-hover>
									</v-list>
								</div>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>

				<!-- FOOTER -->

			</v-card>
		</v-dialog>

		<!-- Dialog adicionar lei a vade-mécum -->
		<v-dialog width="500px" v-model="showDialogAddToVade">
			<v-card>
				<v-card-title>Adicionar lei a um vade-mécum</v-card-title>
				<v-card-text>
					<h3>Selecione o vade-mécum</h3>
					<v-select :items="vademecum" item-value="id" item-text="titulo" color="#F15A24"
						v-model="addTo.vademecum"></v-select>
				</v-card-text>
				<v-card-actions class="text-center">
					<v-btn color="#F15A24" dark @click="patchLeiToVadeMecum">Adicionar Vade-mécum</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog ver leis do vade-mécum -->
		<v-dialog v-model="showDialogVerLeis" fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card class="fullscreen-dialog">
				<!-- Header escuro superior -->
				<v-toolbar dark color="grey darken-3" class="elevation-0">
					<v-toolbar-title class="text-h6 font-weight-bold">
						<v-icon :color="vademecumSeleceted.cor || '#F15A24'" size="20">mdi-circle</v-icon>

						{{ vademecumSeleceted.titulo || 'Vade-mécum' }}
						
					</v-toolbar-title>
					<v-spacer></v-spacer>
						<!-- Visibilidade -->
						
							<!-- Label -->
							<!-- <small class="grey--text ml-3" style="min-width: 90px;">Visibilidade</small> -->
							<!-- Ícone dinâmico - CORRIGIDO -->
							<v-icon :color="vademecumSeleceted.status === 'public' ? '#4CAF50' : '#757575'"
								class="mr-2">
								{{ vademecumSeleceted.status === 'public' || vademecumSeleceted.status == "published" ? 'mdi-eye' : 'mdi-eye-off' }}
							</v-icon>

							<!-- Texto dinâmico -->
							<span class="text-body-2 mr-2" style="min-width:70px;">
								{{ getStatusText(vademecumSeleceted.status) }}
						
							</span>

							<!-- Switch corrigido -->
							<v-switch :input-value="vademecumSeleceted.status === 'public'"
							v-if="!vademecumSeleceted.locked"

								@change="toggleVadeMecumStatus" color="#F15A24" hide-details style="margin-top:-2px" />
						
					<v-spacer></v-spacer>
					<v-btn icon @click="showDialogVerLeis = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<!-- Header branco com busca e ações -->
				<v-card class="elevation-0 pa-4" style="background-color: #f8f9fa;">
					<v-row  >
						<!-- Botões -->
						<v-col cols="12" md="6" class="d-flex justify-start align-center mobileConfig" v-if="!vademecumSeleceted.locked">
						
							<v-btn color="#F15A24" dark @click="showDialogAddLeiToVade = true" class="mr-2">
								<v-icon class="mr-1">mdi-plus</v-icon>
								Adicionar legislação
							</v-btn>
							<v-btn outlined color="#F15A24" 
								@click="() => { showDialogAddProjetoLeiToVade = true; searchProjetoLeisInVadeMecum() }">
								<v-icon color="#F15A24" class="mr-1">mdi-plus</v-icon>
								Adicionar projeto de lei
							</v-btn>
						</v-col>
						<v-col cols="12" md="6" class="d-flex justify-end mobileConfig" v-if="vademecumSeleceted.locked">
						<v-btn color="#F15A24" style="color:white;" class="mr-2"
							:loading="loadingNewVade" :disabled="loadingNewVade" @click="importarVadeMecum">
								<v-icon class="mr-1">mdi-import</v-icon>
								Importar vade-mécun
							</v-btn>
						</v-col>

					

				

						<!-- Busca -->
						<v-col cols="12" md="6">
							<v-text-field
								clearable
								v-model="buscaVadeMecum"
								:append-icon="'mdi-magnify'"
								color="#F15A24"
								hide-details
								outlined
								placeholder="Buscar por termo específico em todas legislações do seu vade-mécun"
								label="Buscar por termo específico em todas legislações do seu vade-mécun"
							/>
						</v-col>
					</v-row>
				</v-card>

				<!-- Conteúdo principal -->
				<v-card-text class="pa-6" style="background-color: white;">
					<!-- Seção de Leis -->
					<div class="mb-6">
						<h3 class="text-h5 font-weight-bold mb-4" style="color: #424242;">
							Leis ({{vademecumSeleceted.leis.length}})
						</h3>
						
						<div v-if="!vademecumSeleceted.leis || vademecumSeleceted.leis.length === 0"
							class="empty-state-box pa-4 text-center">
							<p class="mb-0 grey--text">
								Este vade-mécum ainda não possui legislações. Adicione legislações clicando no botão
								acima ou importando um dos vade-mécuns sugeridos pelo mylegis abaixo.
							</p>
						</div>

					<div v-else>
						<v-card v-for="lei in filteredLeisInVade" :key="lei.id" outlined class="mb-3"
								style="border-radius: 8px;">
								
								
								<v-card-title class="d-flex justify-end"
									style="padding: 0 !important; margin: 0 !important;">
									<v-menu offset-y>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon v-bind="attrs" v-on="on" style="color: #000 !important">
												<v-icon>mdi-dots-vertical</v-icon>
											</v-btn>
										</template>
										
										<v-list>
											<v-list-item>
												<v-btn icon small text color="grey"
													@click="excluirLeiVadeMecum(lei, vademecumSeleceted.id)">
													<v-icon>mdi-delete</v-icon>
												</v-btn>
											</v-list-item>
										</v-list>
									</v-menu>
								</v-card-title>
								<v-card-text class="pa-4">
									<div class="d-flex justify-space-between align-start displayMobile">
										<div class="flex-grow-1">
											<!-- <router-link :to="'/painel/lei/' +
												item.id_lei +
												'/' +
												sanitizeTitle(item.numero_lei)
												"> -->
											<v-btn
												style="background-color: transparent; box-shadow: none; padding: 0; white-space: normal; display: block; text-align: left; justify-content: start;"
												:to="`/painel/lei/${lei.leis_id_lei.id_lei}/${sanitizeTitle(lei.leis_id_lei.numero_lei)}`">
												<h4 class="text-h6 font-weight-bold mb-2"
													style="color: #424242; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
													{{ lei.leis_id_lei.numero_lei }}, DE {{
														formatDate(lei.leis_id_lei.data_lei) }}
												</h4>
											</v-btn>
											
											<!-- </router-link> -->
											<p class="texto-multilinha mb-3 mt-10">
												{{ lei && lei.leis_id_lei ? lei.leis_id_lei.nome_lei : '' }}
											</p>
											<!-- Apelido ou criar apelido -->
											<div
												v-if="lei.leis_id_lei.apelidos_leis && lei.leis_id_lei.apelidos_leis.length > 0">
												<v-text-field v-model="lei.leis_id_lei.apelidos_leis[0].apelido" dense
													outlined hide-details color="#F15A24" style="max-width: 200px;"
													@blur="salvarApelido(lei.leis_id_lei.id_lei, lei.leis_id_lei.apelidos_leis[0].apelido)"
													@keyup.enter="salvarApelido(lei.leis_id_lei.id_lei, lei.leis_id_lei.apelidos_leis[0].apelido)">
													<template v-slot:append>
														<v-btn icon small
															@click="salvarApelido(lei.leis_id_lei.id_lei, lei.leis_id_lei.apelidos_leis[0].apelido)">
															<v-icon color="#F15A24" small>mdi-check</v-icon>
														</v-btn>
													</template>
												</v-text-field>
											</div>
											<div v-else>
												<v-btn @click="criarApelido(lei)" text x-small
													v-if="lei.leis_id_lei.apelidos_leis.length === 0">
													<v-icon color="#F15A24" x-small text class="mr-1">mdi-plus</v-icon>
													Criar apelido
												</v-btn>
												<v-text-field v-if="editNickVadeMecum === lei.leis_id_lei.id_lei"
													v-model="novoApelido" dense outlined hide-details color="#F15A24"
													style="max-width: 200px;" placeholder="Digite o apelido"
													@blur="salvarNovoApelido(lei.leis_id_lei.id_lei)"
													@keyup.enter="salvarNovoApelido(lei.leis_id_lei.id_lei)"
													@keyup.escape="cancelarApelido(lei)">
													<template v-slot:append>
														<v-btn icon small
															@click="salvarNovoApelido(lei.leis_id_lei.id_lei)">
															<v-icon color="#F15A24" small>mdi-check</v-icon>
														</v-btn>
														<v-btn icon small @click="cancelarApelido(lei)">
															<v-icon color="grey" small>mdi-close</v-icon>
														</v-btn>
													</template>
												</v-text-field>
											</div>
										</div>

										<!-- Tags e ações -->
										<div class="d-flex flex-column ">
											<span style="display: flex; gap: 10px; align-items: center;">
												<v-chip color="#F15A24" outlined
													:class="$vuetify.breakpoint.mobile ? `mt-1` : ``"
													text-color="#F15A24" style="height: 1.5rem">
													{{ lei.leis_id_lei.esfera_lei }}
												</v-chip>
												<v-chip class="ml-2" :class="$vuetify.breakpoint.mobile ? `mt-1` : ``"
													outlined color="#F15A24" text-color="#F15A24"
													v-if="lei.leis_id_lei.esfera_lei === `Estadual`"
													style="height: 1.5rem">
													{{ lei.leis_id_lei.estado_lei }}
												</v-chip>
												
											</span>
											
											<!-- <div class="d-flex mt-2 mobileGap">
												
												</div> -->
										</div>
									</div>
									</v-card-text>
									<v-card-actions class="d-flex justify-end p-2 mr-5">
										<v-btn small text color="#F15A24"
											:to="`/painel/lei/${lei.leis_id_lei.id_lei}/${sanitizeTitle(lei.leis_id_lei.numero_lei)}`">
											<v-icon>mdi-file-document</v-icon> ver
										</v-btn>
									</v-card-actions>
								</v-card>

							</div>
						</div>

						<!-- Seção de Projetos de Lei -->
						<div class="mb-6">
							<h3 class="text-h5 font-weight-bold mb-4" style="color: #424242;">Projetos de Lei</h3>
							<div class="empty-state-box pa-4 text-center" v-if="vademecumSeleceted.projetos_leis.length === 0">
								<p class="mb-0 grey--text">Este vade-mécum ainda não possui projetos de lei. Adicione projetos de lei clicando no botão acima.</p>
							</div>
						</div>
					<div v-if="vademecumSeleceted.projetos_leis.length > 0">
						<v-card v-for="lei in filteredProjetosInVade" :key="lei.id" :disabled="lei.retornoBusca ? lei.retornoBusca.length === 0 : false" outlined class="mb-3" style="border-radius: 8px;">
								<v-card-title class="d-flex justify-end" style="padding: 0 !important; margin: 0 !important;">
									<v-menu offset-y>
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon v-bind="attrs" v-on="on" style="color: #000 !important">
												<v-icon>mdi-dots-vertical</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item>
												<v-btn icon small text color="grey" :loading="lei.deleting" @click="excluirProjetoLeiVadeMecum(lei, vademecumSeleceted.id)"><v-icon>mdi-delete</v-icon></v-btn>
											</v-list-item>
										</v-list>
									</v-menu>
								</v-card-title>
								<v-card-text class="pa-4">
									<div class="d-flex justify-space-between align-start displayMobile">
										<div class="flex-grow-1">
											<h4 class="text-h6 font-weight-bold mb-2" style="color: #424242;">{{ lei.projetos_leis_id.numero }}</h4>
											<p class="text-body-1 mb-3" style="color: #666;">{{ lei.projetos_leis_id.nome }}</p>
										</div>
										<div class="d-flex flex-column align-end">
											<span style="display: flex; align-items: center;">
												<v-chip color="#F15A24" outlined :class="$vuetify.breakpoint.mobile ? `mt-1` : ``" text-color="#F15A24" style="height: 1.5rem">{{ lei.projetos_leis_id.esfera }}</v-chip>
												<v-chip class="ml-2" :class="$vuetify.breakpoint.mobile ? `mt-1` : ``" outlined color="#F15A24" text-color="#F15A24" v-if="lei.projetos_leis_id.esfera === `Estadual`" style="height: 1.5rem">{{ lei.projetos_leis_id.estado }}</v-chip>
											</span>
										</div>
									</div>
								</v-card-text>
								<v-card-actions class="d-flex justify-end p-2 mr-5">
									<v-btn small text color="#424242" @click.stop="verProjetoLei(lei)" :disabled="navigating">
										<v-icon>mdi-file-document</v-icon> ver
									</v-btn>
								</v-card-actions>
							</v-card>
						</div>
					</v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog :fullscreen="$vuetify.breakpoint.mobile" width="900px" v-model="showDialogAddProjetoLeiToVade">
			<v-card>
				<v-card-title>
					<v-row>
						<v-col cols="9">
							Adicionar projeto de lei em
							<span :style="{ color: vademecumSeleceted.cor }">{{ vademecumSeleceted.titulo }}</span>
						</v-col>
						<v-col cols="3" class="d-flex align-center justify-end">
							<v-btn @click="showDialogAddProjetoLeiToVade = false" x-large icon>
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12">
							<v-text-field v-on:keyup.enter="searchProjetoLeisInVadeMecum"
								:disable="loadingInternalSearch" clearable v-model="searchAddProjetoLeis"
								@click:clear="clearProjetoLeiInternalSearch"
								@click:append="searchProjetoLeisInVadeMecum"
								:append-icon="loadingProjetoLeiSearch ? `mdi-loading` : `mdi-magnify`" color="#F15A24"
								hide-details outlined
								placeholder="Pesquise pelo número do PL, palavra da ementa ou autor"
								label="Pesquise pelo número do PL, palavra da ementa ou autor" />
						</v-col>
						<v-col cols="12" md="8">
							<h4>Filtre por esfera</h4>
							<v-btn-toggle v-model="filterEsferaProjetoLei" mandatory color="#F15A24" class="ml-3"
								@change="searchProjetoLeisInVadeMecum">
								<v-row>
									<v-col cols="6" class="px-0 mx-0" v-for="o in filterProjetoLeiOptions"
										:key="o.value">
										<v-btn class="mx-0 rounded-0 " color="#F15A24" outlined>{{ o.text }}</v-btn>
									</v-col>
								</v-row>
							</v-btn-toggle>
						</v-col>
						<v-col cols="12" md="4">
							<v-select class="ml-2" v-if="filterEsferaProjetoLei == 1"
								:items="selectEstadualProjetoLeiOptions" v-model="selectEstadualSelected"
								label="Selecione o estado" outlined hide-details @change="searchLeisInVadeMecum"
								item-color="#F15A24" color="#F15A24" item-text="text" item-value="value"></v-select>
							<!-- <v-select
								class="ml-2"
								v-if="filterEsfera == 3"
								label="Selecione o município"
								:items="selectMunicipalOptions"
								v-model="selectMunicipalSelected"
								@change="searchLeisInVadeMecum"
								
								outlined
								hide-details
								color="#F15A24"
								item-color="#F15A24"
								item-text="text"
								item-value="value"
							></v-select> -->
						</v-col>
					</v-row>
					<v-divider class="my-5"></v-divider>
					<!-- <h2 v-if="filterEsfera > 0 || searchAddLeis != ``">
						Total de {{ this.totalItems }} leis 
					</h2> -->
					<v-list class="mt-3">
						<v-list-item class="px-0 text-center d-flex justify-center"
							v-if="loadingProjetoLeiInternalSearch">
							<v-progress-circular indeterminate></v-progress-circular>
						</v-list-item>
						<v-list-item class="px-0 text-center d-flex justify-center"
							v-if="internalProjetoLeisSearch.length === 0 && !loadingProjetoLeiInternalSearch">
							<p>Nenhuma legislação encontrada, confira os filtros acima.</p>
						</v-list-item>
						<v-hover v-slot="{ hover }"
							v-for="item in internalProjetoLeisSearch.slice(((currentPage - 1) * itemsPerPage), ((currentPage - 1) * itemsPerPage) + itemsPerPage)"
							:key="item.id_lei">
							<v-list-item :class="hover ? `bkgHover` : ``"
								style="border-top: 1px solid #F15A24; border-radius: 10px"
								class="mb-5"><v-list-item-content>
									<v-row align="center" class="mb-2" no-gutters>
										<v-col class="pa-0">
											<v-list-item-title>
												<span v-html="highlight(item.numero, searchAddLeis)"></span>
											</v-list-item-title>
										</v-col>
										<v-col class="pa-0 mt-1">
											<v-chip class="mr-2" color="#F15A24" outlined text-color="#F15A24"
												style="height: 1.5rem">
												{{ item.esfera }}
											</v-chip>
											<v-chip color="#F15A24" outlined text-color="#F15A24"
												v-if="item.esfera === `Estadual`" style="height: 1.5rem">
												{{ item.estado }}
											</v-chip>
											<v-chip class="ml-2" color="#F15A24" outlined text-color="#F15A24"
												v-if="item.esfera === `Municipal`" style="height: 1.5rem">
												{{ item.municipio }}
											</v-chip>
										</v-col>
									</v-row>
									<div>
										<small class="mb-5" v-html="highlight(item.nome, searchAddLeis)"></small><br>
										Autor {{ item.autor }}
									</div>
								</v-list-item-content>

								<v-list-item-action class="text-center">
									<span class="text-subtitle" style="min-width: 90px; text-transform: uppercase" v-if="
										vademecumSeleceted.projetos_leis.find(
											(e) => parseInt(e.projetos_leis_id.id) === item.id
										)
									">
										Adicionado
									</span>
									<v-btn v-else small text color="#F15A24" :loading="item.loading"
										@click="item.loading = true; addProjetoLeiToVade(item, vademecumSeleceted.id)"
										:disabled="isProjetoLeiInVade(item.id, vademecumSeleceted.projetos_leis)
											">
										Adicionar
									</v-btn>
								</v-list-item-action>
							</v-list-item>
						</v-hover>
					</v-list>
					<div class="d-flex justify-center mt-4">
						<v-pagination v-if="totalItems > itemsPerPage" v-model="currentPage" :total-visible="5"
							:length="Math.ceil(totalItems / itemsPerPage)" color="#F15A24" @input="handlePageChange"
							class="mt-4">
						</v-pagination>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Dialog adicionar legislação ao vade-mécum -->
		<v-dialog :fullscreen="$vuetify.breakpoint.mobile" width="900px" v-model="showDialogAddLeiToVade">
			<v-card>
				<v-card-title>
					<v-row>
						<v-col cols="9">
							Adicionar legislação em
							<span :style="{ color: vademecumSeleceted.cor }">{{ vademecumSeleceted.titulo }}</span>
						</v-col>
						<v-col cols="3" class="d-flex align-center justify-end">
							<v-btn @click="showDialogAddLeiToVade = false" x-large icon>
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12">
							<v-text-field v-on:keyup.enter="searchLeisInVadeMecum" :disable="loadingInternalSearch"
								clearable v-model="searchAddLeis" @click:clear="clearInternalSearch"
								@click:append="searchLeisInVadeMecum"
								:append-icon="loadingSearch ? `mdi-loading` : `mdi-magnify`" color="#F15A24"
								hide-details outlined
								placeholder="Pesquise pelo número da lei (10.406) ou palavra da ementa (Código Civil)"
								label="Pesquise pelo número da lei (10.406) ou palavra da ementa (Código Civil)" />
						</v-col>
						<v-col cols="12" md="8">
							<h4>Filtre por esfera</h4>
							<v-btn-toggle v-model="filterEsfera" mandatory color="#F15A24" class="ml-3"
								@change="searchLeisInVadeMecum">
								<v-row>
									<v-col cols="6" md="3" class="px-0 mx-0" v-for="o in filterOptions" :key="o.value">
										<v-btn class="mx-0 rounded-0 w-100" color="#F15A24" outlined>{{ o.text}}</v-btn>
									</v-col>
								</v-row>
							</v-btn-toggle>
						</v-col>
						<v-col cols="12" md="4">
							<v-select class="ml-2" v-if="filterEsfera == 2" :items="selectEstadualOptions"
								v-model="selectEstadualSelected" label="Selecione o estado" outlined hide-details
								@change="searchLeisInVadeMecum" item-color="#F15A24" color="#F15A24" item-text="text"
								item-value="value"></v-select>
							<v-select class="ml-2" v-if="filterEsfera == 3" label="Selecione o município"
								:items="selectMunicipalOptions" v-model="selectMunicipalSelected"
								@change="searchLeisInVadeMecum" outlined hide-details color="#F15A24"
								item-color="#F15A24" item-text="text" item-value="value"></v-select>
						</v-col>
					</v-row>
					<v-divider class="my-5"></v-divider>
					<!-- v-if="filterEsfera > 0 || searchAddLeis != ``" -->
					<h2 >
						Total de {{ new Intl.NumberFormat("pt-BR").format(this.totalItems) }} leis 
					</h2>
					<v-list class="mt-3">
						<v-list-item class="px-0 text-center d-flex justify-center" v-if="loadingInternalSearch">
							<v-progress-circular indeterminate></v-progress-circular>
						</v-list-item>
						<v-list-item class="px-0 text-center d-flex justify-center"
							v-if="internalLeisSearch.length === 0 && !loadingInternalSearch">
							<p>Nenhuma legislação encontrada, confira os filtros acima.</p>
						</v-list-item>
						<v-hover v-slot="{ hover }" v-for="item in internalLeisSearch" :key="item.id_lei">
							<v-list-item :class="hover ? `bkgHover` : ``"
								style="border-top: 1px solid #F15A24; border-radius: 10px"
								class="mb-5"><v-list-item-content>
									<v-row align="center" class="mb-2" no-gutters>
										<v-col class="pa-0">
											<v-list-item-title>
												<span v-html="highlight(item.numero_lei, searchAddLeis)"></span>
											</v-list-item-title>
										</v-col>
										<v-col class="pa-0 mt-1">
											<v-chip class="mr-2" color="#F15A24" outlined text-color="#F15A24"
												style="height: 1.5rem">
												{{ item.esfera_lei }}
											</v-chip>
											<v-chip color="#F15A24" outlined text-color="#F15A24"
												v-if="item.esfera_lei === `Estadual`" style="height: 1.5rem">
												{{ item.estado_lei }}
											</v-chip>
											<v-chip class="ml-2" color="#F15A24" outlined text-color="#F15A24"
												v-if="item.esfera_lei === `Municipal`" style="height: 1.5rem">
												{{ item.municipio_lei }}
											</v-chip>
										</v-col>
									</v-row>
									<div>
										<small v-html="highlight(item.nome_lei, searchAddLeis)"></small>
									</div>
								</v-list-item-content>

								<v-list-item-action class="text-center">
									<span class="text-subtitle" style="min-width: 90px; text-transform: uppercase" v-if="
										vademecumSeleceted.leis.find(
											(e) => parseInt(e.leis_id_lei.id_lei) === item.id_lei
										)
									">
										Adicionado
									</span>
									<v-btn v-else small text color="#F15A24" :loading="item.loading"
										@click="item.loading = true; addLeiToVade(item, vademecumSeleceted.id)"
										:disabled="isLeiInVade(item.id_lei, vademecumSeleceted.leis)
											">
										Adicionar
									</v-btn>
								</v-list-item-action>
							</v-list-item>
						</v-hover>
					</v-list>
					<div class="d-flex justify-center mt-4">
						<v-pagination v-if="totalItems > itemsPerPage" v-model="currentPage" :total-visible="5"
							:length="Math.ceil(totalItems / itemsPerPage)" color="#F15A24" @input="handlePageChange"
							class="mt-4">
						</v-pagination>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Dialog sugestão -->
		<v-dialog width="580px" v-model="showDialogSugestao">
			<v-card>
				<v-card-title class="d-flex justify-space-between">
					<p class="mb-0">Enviar um sugestão</p>
					<v-btn @click="showDialogSugestao = false;" icon>
						X
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-textarea clearable v-model="txtSugestao" color="#f57029"
						placeholder="Escreva aqui a sua sugestão" />
				</v-card-text>
				<v-card-actions class="text-center">
					<v-btn color="#F15A24" dark @click="sendSugestion">Enviar Sugestão</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<style scoped>
.search-field ::v-deep .v-input__slot {
	border-radius: 4px;
	background-color: white;
}

.borda-laranja {
	border: 1px solid #f15a24;
	border-radius: 20px;
	padding: 3px;
}

.boxText {
	background-color: #f15a24;
	padding: 5px 15px;
	color: white;
	width: 185px;
	height: 42px;
	font-size: 22px;
}

.vademecum-card {
	border-radius: 12px;
	transition: all 0.3s ease;
	height: auto;
}

.vademecum-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

a {
	text-decoration: none;
}

a:hover h2,
a:hover p {
	text-decoration: underline;
}

.resumoNoticia {
	font-size: 1.1rem !important;
	white-space: initial;
}

.highlightText {
	color: red;
}

.bkgHover {
	background-color: rgba(0, 0, 0, 0.08) !important
}

.fullscreen-dialog {
	height: 100vh;
	overflow-y: auto;
}

.empty-state-box {
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	background-color: #fafafa;
}

.dialog-bottom-transition-enter-active,
.dialog-bottom-transition-leave-active {
	transition: transform 0.3s ease-in-out;
}

.dialog-bottom-transition-enter,
.dialog-bottom-transition-leave-to {
	transform: translateY(100%);
}

.search-container {
	background-color: #f5f5f5;
	border-radius: 4px;
	margin: 0 auto;
}

@media (max-width: 600px) {
	.displayMobile {
		display: block !important;
	}

	.mobileAlign {
		justify-content: center !important;
	}

	.mobileGap {
		gap: 24px;
	}

	.mobileConfig {
		display: grid !important;
		justify-content: center !important;
		gap: 10px !important;
	}
}

.texto-multilinha {
	color: #666;
	font-size: 0.875rem;

	/* Trunca após 2 linhas */
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.4;
	max-height: calc(1.4em * 2);
	/* altura de 2 linhas */
}
</style>

<script>
//import BtnCompartilhar from "../components/BtnCompartilahr.vue";
export default {
	name: 'Legislacoes',
	//components: { BtnCompartilhar },
	data() {
		return {
			// nick: '',
			// nicks: [],
			idleis: [],
			filterEsfera: 0,
			filterEsferaProjetoLei: 0,
			showVadeDialog: false,
			editNickVadeMecum: 0,
			novoApelido: '',
			editing: [],
			showDialogVerLeis: false,
			showDialogAddLeiToVade: false,
			showDialogAddProjetoLeiToVade: false,
			vademecumSeleceted: { projetos_leis: [], leis: [], edit: false },
			navigating: false,
			statusVadeMecun: [
				{ id: 'published', text: 'Privado' },
				{ id: 'public', text: 'Público' },
			],
			vademecum: [],
			addTo: {},
			showDialogAddVade: false,
			first: false,
			showDialogAddToVade: false,
			loadingNewVade: false,
			loadingNewNick: false,
			disable: true,
			newVadeMecum: '',
			newVadeMecumColor: '',
			page: 1,
			perPageSelected: 0,
			perPage: [5, 10, 25],
			order: 'ASC',
			searchNoticia: null,
			buscou: false,
			resetPages: false,
			loading: true,
			selected: [],
			noticiasDestaque: [],
			items: [],
			searchAddLeis: '',
			searchAddProjetoLeis: '',
			filterOptions: [
				{ text: 'Todas', value: 'Todos', disabled: false },
				{ text: 'Federal', value: 'Federal', disabled: false },
				{ text: 'Estadual', value: 'Estadual', disabled: false },
				{ text: 'Municipal', value: 'Municipal', disabled: false },
			],
			filterProjetoLeiOptions: [
				{ text: 'Todas', value: 'Todos', disabled: false },
				// { text: 'Federal', value: 'Federal', disabled: false },
				{ text: 'Estadual', value: 'Estadual', disabled: false },
				// { text: 'Municipal', value: 'Municipal', disabled: false },
			],
			selectEstadualProjetoLeiOptions: [
				{ text: 'Todos', value: '*', disabled: false },
				{ text: 'Rio de Janeiro', value: 'RJ', disabled: false },
			],
			selectEstadualOptions: [
				{ text: 'Todos', value: '*', disabled: false },
				{ text: 'Rio de Janeiro', value: 'RJ', disabled: false },
				{ text: 'São Paulo', value: 'SP', disabled: false },
				{ text: 'Belo Horizonte', value: 'MG', disabled: false },
			],
			selectMunicipalOptions: [
				{ text: 'Todos', value: '*', disabled: false },
				{ text: 'Rio de Janeiro', value: 'RJ', disabled: false },
				{ text: 'São Paulo', value: 'SP', disabled: false },
			],
			selectEstadualSelected: '*',
			selectMunicipalSelected: '*',
			currentPage: 1,
			itemsPerPage: 10,
			patchLoading: [],
			internalLeisSearch: [],
			internalProjetoLeisSearch: [],
			imgs: [],
			totalItems: 0,
			totalFiltrado: 0,
			loadingInternalSearch: false,
			loadingProjetoLeiInternalSearch: false,
			loadingSearch: false,
			loadingProjetoLeiSearch: false,
			filterTags: [],
			allTags: [],
			swatches: [
				['#FF0000', '#AA0000', '#550000'],
				['#FFFF00', '#AAAA00', '#555500'],
				['#00FF00', '#00AA00', '#005500'],
				['#00FFFF', '#00AAAA', '#005555'],
				['#0000FF', '#0000AA', '#000055'],
			],
			snack: {
				show: false,
				text: 'Favoritado com sucesso',
			},
			resultadoBusca: [],
			buscaVadeMecum: '',
			savingVadeMecum: false,
			showDialogSugestao: false,
			txtSugestao: '',
			// novos estados
			loadingSuggestedVades: false,
			suggestedVademecuns: [],
		};
	},
	created() {
		this.loading = true;
		this.reloadVadeMecum();
		this.searchLeisInVadeMecum();
		this.loadSuggestedVademecuns();

		// this.reloadLeisGraphQl()
	},



	methods: {

		toggleVadeMecumStatus(isPublic) {
			const newStatus = isPublic ? 'public' : 'private';
			this.updateVadeMecumStatus(newStatus);
		},

		// Método para atualizar o status no backend
		async updateVadeMecumStatus(newStatus) {
			this.savingVadeMecum = true;

			try {
				await this.$http.patch('/items/vademecums/' + this.vademecumSeleceted.id, {
					status: newStatus
				});

				// Atualizar o status localmente
				this.vademecumSeleceted.status = newStatus;

				// Atualizar na lista de vademecums também
				const vadeIndex = this.vademecum.findIndex(v => v.id === this.vademecumSeleceted.id);
				if (vadeIndex !== -1) {
					this.vademecum[vadeIndex].status = newStatus;
				}

				window.console.log('Status atualizado com sucesso:', newStatus);

			} catch (error) {
				window.console.error('Erro ao atualizar status:', error);
				// Reverter o status em caso de erro
				// (o v-switch será atualizado automaticamente pela reatividade)
			} finally {
				this.savingVadeMecum = false;
			}
		},

		// Método auxiliar para obter o status formatado
		getStatusText(status) {
			switch (status) {
				case 'published':
					return 'Público';
				case 'public':
					return 'Público';					
				case 'private':
					return 'Privado';
				default:
					return 'Privado';
			}
		},

		// *****************************************************

		addLei(lei) {
			if (!this.selectedLeis.find(l => l.id === lei.id)) {
				this.selectedLeis.push(lei);
			}
		},

		removeLei(lei) {
			this.selectedLeis = this.selectedLeis.filter(l => l.id !== lei.id);
		},

		async importarVadeMecum() {
			window.console.log(this.vademecumSeleceted);
			this.loadingNewVade = true;
			const { data } = await this.$http.post('/items/vademecums', {
				titulo: this.vademecumSeleceted.titulo,
				cor: this.vademecumSeleceted.cor,
				status: 'published',
			});

			const mapLeis = (this.vademecumSeleceted.leis || []).map((e) => ({
				leis_id_lei: { id_lei: e.leis_id_lei.id_lei },
				vademecums_id: data.data.id,
			}));

			const mapProjetos = (this.vademecumSeleceted.projetos_leis || []).map((e) => ({
				projetos_leis_id: { id: e.projetos_leis_id.id },
				vademecums_id: data.data.id,
			}));

			for (const law of mapLeis) {
				const lawId = law.leis_id_lei.id_lei;
				const vademecumId = law.vademecums_id;
				
				// Buscar anotações do usuário que criou o vade mecum original
				const responseAnnotations = await this.$http.get(
					`/items/anotacoes?filter[id_lei][_eq]=${lawId}&filter[user_created][_eq]=${this.vademecumSeleceted.user_created}&filter[status][_eq]=published&fields=id_reg,texto,status`
				);
				
				if (responseAnnotations.data.data.length > 0) {
					for (const annotation of responseAnnotations.data.data) {
						// Criar única anotação com status privado
						await this.$http.post(`/items/anotacoes`, {
							status: 'private',
							texto: annotation.texto,
							id_lei: lawId,
							id_reg: annotation.id_reg,
							id_vademecum: vademecumId,
						});
					}
				}
			}

			await this.$http.patch('/items/vademecums/' + data.data.id, {
				...(mapLeis.length > 0 ? { leis: { create: mapLeis } } : {}),
				...(mapProjetos.length > 0 ? { projetos_leis: { create: mapProjetos } } : {}),
			});
			
			this.loadingNewVade = false;
			this.showDialogVerLeis = false;
			this.reloadVadeMecum()
			// this.$router.go("/painel/legislacoes")
		},
		translateVadeMecunStatus(status) {
			switch (status) {
				case 'published':
					return 'Privado';
				case 'public':
					return 'Público';
				default:
					return 'Privado';
			}
		},
		sendSugestion() {

			window.open("https://wa.me/5521991644663?text=" + this.txtSugestao, "_blank")

			// this.$http
			// 	.post('/items/suporte', {
			// 		mensagem: this.txtSugestao,
			// 	})
			// 	.then(() => {
			// 		this.txtSugestao = '';
			// 		this.showDialogSugestao = false;
			// 		alert(
			// 			'Obrigado por nos enviar sua sugestão, retornaremos o mais breve possível.'
			// 		);
			// 	});
		},
		isLeiInVade(id_lei, leis) {
			return leis.some((lei) => lei.leis_id_lei.id_lei === id_lei);
		},
		isProjetoLeiInVade(projetoLeiId, leis) {
			return leis.some((lei) => lei.projetos_leis_id.id === projetoLeiId);
		},
		excluirLeiVadeMecum(rel, idVadeMecum) {
			rel.deleting = true;
			this.$http
				.patch('/items/vademecums/' + idVadeMecum, {
					leis: { delete: [rel.id] },
				})
				.then(() => {
					this.reloadVadeMecum(idVadeMecum);
					rel.deleting = false;
				});
			this.$http.get('/items/leis/' + rel.leis_id_lei.id_lei).then((res) => {
				if (res) {
					const newRanking = res.data.data.ranking_lei - 1;
					this.$http.patch('/items/leis/' + rel.leis_id_lei.id_lei, {
						ranking_lei: newRanking,
					});
				}
			});
		},
		excluirProjetoLeiVadeMecum(rel, idVadeMecum) {
			rel.deleting = true;
			this.$http
				.patch('/items/vademecums/' + idVadeMecum, {
					projetos_leis: { delete: [rel.id] },
				})
				.then(() => {
					this.reloadVadeMecum(idVadeMecum);
					rel.deleting = false;
				});

		},
		verProjetoLei(lei) {
			// Prevenir múltiplas chamadas
			if (this.navigating) {
				return;
			}
			
			this.navigating = true;
			
			// Construir a URL primeiro
			const url = `/painel/projeto_lei/${lei.projetos_leis_id.id}/${this.sanitizeTitle(lei.projetos_leis_id.numero)}/${this.sanitizeTitle(this.vademecumSeleceted.titulo)}`;
			
			// Fechar o dialog
			this.showDialogVerLeis = false;
			
			// Aguardar o próximo tick e um pequeno delay para garantir que o dialog feche
			this.$nextTick(() => {
				setTimeout(() => {
					// Navegar para a rota, ignorando erros de navegação duplicada
					this.$router.push(url).catch(err => {
						// Ignorar erros de navegação duplicada - isso é normal quando já estamos na rota
						if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation')) {
							window.console.error('Erro ao navegar:', err);
						}
					}).finally(() => {
						this.navigating = false;
					});
				}, 150);
			});
		},
		isOptionDisabled(option) {
			return option === 'Municipal (Em Breve)';
		},
		editVD() {
			this.vademecumSeleceted.edit = true;
			this.$refs.edit.focus();
			// window.console.log(this.$refs.edit)
		},
		editarVadeMecum() {
			this.savingVadeMecum = true;
			this.$http
				.patch('/items/vademecums/' + this.vademecumSeleceted.id, {
					titulo: this.vademecumSeleceted.titulo,
					cor: this.vademecumSeleceted.cor,
					status: this.vademecumSeleceted.status,
				})
				.then(() => {
					this.savingVadeMecum = false;
					this.vademecumSeleceted.edit = false;
					this.reloadVadeMecum();
				});
		},
		excluirVadeMecum(v) {
			if (
				confirm(
					`Você deseja excluir o vade-mécum ${v.titulo ? v.titulo : ''} ?`
				)
			) {
				this.$http
					.patch('/items/vademecums/' + v.id, {
						status: 'archived',
					})
					.then(() => {
						this.reloadVadeMecum();
					});
			}
		},
		clearVadeMecumBusca() {
			this.vademecumSeleceted.leis.forEach((lei) => {
				lei.retornoBusca = undefined;
			});
			this.buscaVadeMecum = '';

			this.$forceUpdate();
		},
		handlePageChange(page) {
			if (page >= 1 && page <= this.totalPages) {
				this.currentPage = page;
				if (!this.showDialogAddProjetoLeiToVade) this.searchLeisInVadeMecum();
			}
		},
		clearInternalSearch() {
			this.searchAddLeis = '';
			this.totalItems = 0;
			this.internalLeisSearch = [];
			this.currentPage = 1;
			this.searchLeisInVadeMecum();
		},
		clearProjetoLeiInternalSearch() {
			this.searchAddProjetoLeis = '';
			this.totalItems = 0;
			this.internalProjetoLeisSearch = [];
			this.currentPage = 1;
			this.searchProjetoLeisInVadeMecum();
		},
		async reloadVadeMecum(idVadeMecum) {
			const query = `query FilterVadeMecumsByApelidosLeis($user_id:String){
   vademecums(sort: ["-date_created"], filter: { 
     status: {_neq: "archived"}, 
     user_created: { id: { _eq: $user_id}}
   }) {
     id
     titulo
     status
     cor
     leis {
       id
       leis_id_lei {
         id_lei
         numero_lei
         data_lei
         estado_lei
         esfera_lei
         nome_lei
         apelidos_leis (sort:["-date_created"], filter: { user_created: { id: { _eq: $user_id}}}){
           id
           apelido
         }
       }
     }
     projetos_leis { 
       id
       projetos_leis_id { 
         id
         numero
         data
         estado
         esfera
         nome
       }
     }
   }
 }`;

			const variables = { user_id: this.user.id };
			const {
				data: { data },
			} = await this.$http.post('/graphql', {
				query,
				variables,
			});
			this.vademecum = data.vademecums;
			if (idVadeMecum) {
				this.vademecumSeleceted = this.vademecum.filter(
					(e) => e.id == idVadeMecum
				)[0];
			}
			if (this.vademecum.length === 0) {
				this.showVadeDialog = true;
			}
		},

		// Buscar Vades Mecuns públicos do perfil Mylegis
		async loadSuggestedVademecuns() {
			try {
				this.loadingSuggestedVades = true;
				// Buscar o usuário "Mylegis" de forma tolerante
				const usersRes = await this.$http.get(
					`/users?limit=1&fields=id,first_name&filter[_or][0][first_name][_icontains]=mylegis&filter[_or][1][last_name][_icontains]=mylegis`
				);
				const users = usersRes && usersRes.data && usersRes.data.data ? usersRes.data.data : [];
				if (users.length === 0) {
					this.suggestedVademecuns = [];
					return;
				}
				const mylegisId = users[0].id;
				// Buscar vade-mécuns públicos desse usuário (aceitando public/published)
				const vadesRes = await this.$http.get(
					`/items/vademecums?fields=*,leis.id,leis.leis_id_lei.*&sort=-date_created&filter[user_created][_eq]=${mylegisId}&filter[status][_in]=public`
				);
				this.suggestedVademecuns = vadesRes && vadesRes.data && vadesRes.data.data ? vadesRes.data.data : [];
			} catch (e) {
				window.console.error('Erro ao carregar vades sugeridos:', e);
			} finally {
				this.loadingSuggestedVades = false;
			}
		},


		mapEsferaColor(esfera) {
			switch (esfera) {
				case 'Federal':
					return '#FF0000';
				case 'Estadual':
					return '#f15a24';
				case 'Municipal':
					return '#00FF00';
				default:
					return '#0000FF';
			}
		},
		patchLeiToVadeMecum() {
			this.loadingNewVade = true;
			// this.addTo.items.push(this.addTo.id)
			this.$http
				.patch('/items/vademecums/' + this.addTo.vademecum, {
					leis: {
						create: [
							{
								leis_id_lei: { id_lei: this.addTo.id_lei },
								vademecums_id: this.addTo.vademecum,
							},
						],
					},
				})
				.then(() => {
					this.loadingNewVade = false;
					this.showDialogAddToVade = false;
					this.newVadeMecum = '';
					// window.console.log(res);
					this.reloadVadeMecum(this.addTo.vademecum);
				});
		},
		postVadeMecum() {
			this.loadingNewVade = true;
			window.console.log(this.idleis);
			this.$http
				.post('/items/vademecums', {
					titulo: this.newVadeMecum,
					cor: this.newVadeMecumColor,
					status: 'published',
				})
				.then(async (data) => {
					// const response = await data.json();
					window.console.log(data.data);
					this.idleis.forEach((id) => {
						this.$http
							.patch('/items/vademecums/' + data.data.data.id, {
								leis: {
									create: [
										{
											leis_id_lei: { id_lei: id },
											vademecums_id: data.data.data.id,
										},
									],
								},
							})
					})

					this.loadingNewVade = false;
					this.showDialogAddVade = false;
					this.newVadeMecum = '';
					this.newVadeMecumColor = '';
					this.reloadVadeMecum();
					this.searchLeisInVadeMecum();
					window.location.reload();
				});
		},
		makeFavorite(lei) {
			this.$http
				.post('/items/favoritos', {
					id_lei: lei.id_lei,
					observacao: '',
				})
				.then((res) => {
					this.snack.show = true;
					window.console.log(res);
				});
		},
		async getTop10Laws() {
			try {
				const response = await this.$http.get(
					'https://api.mylegis.com.br/items/leis?limit=30&sort=-ranking_lei'
				);
				// window.console.log(response);
				const leis = response.data.data;
				this.internalLeisSearch = leis.slice(0, 30).map(v => ({ ...v, loading: false }));
			} catch (error) {
				window.console.log(error);
			}
		},
		async searchLeisInVadeMecum() {
			// this.currentPage = 1;
			if (this.searchAddLeis == null) this.searchAddLeis = ""
			if (!isNaN(this.searchAddLeis) &&
				this.searchAddLeis.indexOf('.') == -1) {
				this.searchAddLeis = this.searchAddLeis.replace(
					/(\d)(?=(\d{3})+$)/g,
					'$1.'
				);
			}

			// window.console.log({ vade: this.vademecumSeleceted });

			const searchQuery = this.searchAddLeis
				? `search:"${this.searchAddLeis}", `
				: '';

			const offset = (this.currentPage - 1) * this.itemsPerPage;
			// window.console.log(this.filterEsfera)

			let filter = 'filter: { esfera_lei: { _nnull: true}}'
			if (this.filterEsfera == 1) {
				filter = `filter: { esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"} }, `
			}

			if (this.filterEsfera == 2) {
				filter = `filter: {  esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"}
					 ${this.selectEstadualSelected !== "*" ? `, estado_lei: { _eq: "${this.selectEstadualSelected}"}` : ``}
					},`
			}
			if (this.filterEsfera == 3) {
				filter = `filter: { esfera_lei: {_eq: "${this.filterOptions[this.filterEsfera].value}"}
					 ${this.selectMunicipalSelected !== "*" ? `, municipio_lei: { _eq: "${this.selectMunicipalSelected}"}` : ``}
					},`
			}


			const query = `
				query FilterByApelidosLeis {
					leis(${filter}${searchQuery}sort: ["-ranking_lei", "-data_lei"], limit: ${this.itemsPerPage}, offset: ${offset}) {
					id_lei
					numero_lei
					data_lei
					nome_lei
					estado_lei
					municipio_lei
					esfera_lei
					ranking_lei
					}
					leis_aggregated(${filter}${searchQuery}) {
					count { id_lei }
					}
				}
				`;

			this.loadingInternalSearch = true;
			this.internalLeisSearch = [];
			this.totalItems = 0
			// window.console.log(query)

			try {
				const response = await this.$http.post(
					'https://api.mylegis.com.br/graphql',
					{ query }
				);
				const { leis, leis_aggregated } = response.data.data;
				this.internalLeisSearch = leis.map(v => ({ ...v, loading: false }));
				this.totalItems = leis_aggregated[0].count.id_lei;
				this.loadingInternalSearch = false;
			} catch (error) {
				this.loadingInternalSearch = false;
				window.console.error('Erro ao buscar as leis:', error.response);
			}
		},
		async searchProjetoLeisInVadeMecum() {
			// this.currentPage = 1;
			if (this.searchAddProjetoLeis == null) this.searchAddProjetoLeis = ""
			// if (!isNaN(this.searchAddProjetoLeis) &&
			// 	this.searchAddProjetoLeis.indexOf('.') == -1) {
			// 	this.searchAddProjetoLeis = this.searchAddProjetoLeis.replace(
			// 		/(\d)(?=(\d{3})+$)/g,
			// 		'$1.'
			// 	);
			// }

			// window.console.log({ vade: this.vademecumSeleceted });

			const searchQuery = this.searchAddProjetoLeis
				? `search:"${this.searchAddProjetoLeis}", `
				: '';

			// const offset = (this.currentPage - 1) * this.itemsPerPage;
			// window.console.log(this.filterEsfera)
			//, codigo: { _neq: "Projeto de Lei"}
			let filter = 'filter: { esfera: { _nnull: true}, numero: { _nnull: true}}'
			if (this.filterEsferaProjetoLei == 1) {
				filter = `filter: { esfera: {_eq: "${this.filterProjetoLeiOptions[this.filterEsferaProjetoLei].value}"} }, `
			}

			if (this.filterEsferaProjetoLei == 2) {
				filter = `filter: {  esfera: {_eq: "${this.filterProjetoLeiOptions[this.filterEsferaProjetoLei].value}"}
					 ${this.selectEstadualSelected !== "*" ? `, estado: { _eq: "${this.selectEstadualSelected}"}` : ``}
					},`
			}
			if (this.filterEsferaProjetoLei == 3) {
				filter = `filter: { esfera: {_eq: "${this.filterProjetoLeiOptions[this.filterEsferaProjetoLei].value}"}
					 ${this.selectMunicipalSelected !== "*" ? `, municipio: { _eq: "${this.selectMunicipalSelected}"}` : ``}
					},`
			}

			//sort: ["-codigo"], limit: ${this.itemsPerPage}, offset: ${offset}
			const query = `
				query FilterByApelidosLeis {
					projetos_leis(${filter}${searchQuery},limit:-1) {
					id
					numero
					data
					nome
					estado
					municipio
					autor
					codigo
					esfera
					ranking
					}
					projetos_leis_aggregated(${filter}${searchQuery}) {
					count { id }
					}
				}
				`;

			this.loadingProjetoLeiInternalSearch = true;
			this.internalProjetoLeisSearch = [];
			this.totalItems = 0
			// window.console.log(query)

			try {
				const response = await this.$http.post(
					'https://api.mylegis.com.br/graphql',
					{ query }
				);
				const { projetos_leis } = response.data.data;
				// this.internalProjetoLeisSearch = projetos_leis.filter(v => v.codigo != `Projeto de Lei` );
				this.internalProjetoLeisSearch = projetos_leis.map(v => ({ ...v, loading: false }))
				const sortedRows = this.internalProjetoLeisSearch.sort((a, b) => {
					const extractNumber = (numeroString) => {
						const match = numeroString.match(/(\d+)\/\d{4}/);
						return match ? parseInt(match[1]) : 0;
					};

					return extractNumber(b.numero) - extractNumber(a.numero);
				});
				this.internalProjetoLeisSearch = sortedRows
				// window.console.log(sortedRows)
				// this.internalProjetoLeisSearch = projetos_leis.map(v => ({...v, loading: false}));
				this.totalItems = this.internalProjetoLeisSearch.length;
				this.loadingProjetoLeiInternalSearch = false;
			} catch (error) {
				this.loadingProjetoLeiInternalSearch = false;
				window.console.error('Erro ao buscar as leis:', error);
			}
		},
		// async reloadApelidos() {
		//   const ids = this.items.map(e => e.id_lei)

		//   const {
		//     data: { data },
		//   } = await this.$http.get(`/items/apelidos_leis?filter[lei][_in]=${ids}&filter[user_created][_eq]=${this.user.id}`);
		//   window.console.log({ids, data})

		// },
		async reloadLeisGraphQl() {
			this.loading = true;
			if (
				this.searchNoticia !== null &&
				!isNaN(this.searchNoticia) &&
				this.searchNoticia.indexOf('.') == -1
			) {
				this.searchNoticia = this.searchNoticia.replace(
					/(\d)(?=(\d{3})+$)/g,
					'$1.'
				);
			}
			let search =
				this.searchNoticia === undefined || this.searchNoticia === null
					? ''
					: `search:"${this.searchNoticia}",`;
			const query = `query FilterByApelidosLeis($user_id:String){
	         leis(${search} sort:["${this.order === 'ASC' ? '-' : ''}data_lei"],
	               limit: ${this.perPage[this.perPageSelected]},
	               offset: ${(this.page - 1) * this.perPage[this.perPageSelected]
				}) {
	           id_lei
	           numero_lei
	           data_lei
			   estado_lei
	           nome_lei
	           apelidos_leis (filter: { user_created: { id: { _eq: $user_id}}}){
	               apelido
	           }
	         }
	         leis_aggregated${search === '' ? `` : `(${search})`} {
	           count { id_lei }
	         }
	     }`;
			const variables = { user_id: this.user.id };
			const {
				data: { data },
			} = await this.$http.post('/graphql', {
				query,
				variables,
			});
			// window.console.log(data)
			this.totalItems = data.data.meta.total_count;
			this.totalFiltrado = data.leis_aggregated[0].count.id_lei;
			this.loading = false;
			if (this.resetPages) {
				this.page = 1;
				this.resetPages = false;
			}
			this.items = data.leis;

			if (this.first) {
				document
					.querySelector('#busca')
					.scrollIntoView({ behavior: `smooth` });
			} else {
				this.first = true;
			}
		},
		reloadLeis() {
			this.reloadLeisGraphQl();
			return;
		},
		oldReloadLeis() {
			let search =
				this.searchNoticia === undefined || this.searchNoticia === null
					? ''
					: 'search=' + this.searchNoticia;
			let sort = `&sort=${this.order === 'ASC' ? '-' : ''}data_lei`;
			let limit = '&limit=' + this.perPage[this.perPageSelected];
			let offset =
				'&offset=' + (this.page - 1) * this.perPage[this.perPageSelected];
			// let filter = "&filter[apelidos_leis][user_created][id][_eq]="+ this.user.id;
			let filter = '';
			// let filters = []
			// this.filterTags.forEach((el,i) => {
			//   if (el) {
			//     filters.push(this.allTags[i])
			//   }
			// })
			// let filter1 = filters.length === 0 ? "" : "&filter[tags][_contains]="+filters.join()
			let meta = '&meta=total_count,filter_count';

			this.loading = true;
			this.items = [];
			this.$http({
				url:
					'items/leis?fields=id_lei,nome_lei,data_lei,numero_lei&' +
					filter +
					search +
					sort +
					limit +
					offset +
					meta,
			}).then(
				(data) => {
					this.items = data.data.data;
					// this.totalItems = data.data.meta.total_count;
					this.totalFiltrado = data.data.meta.filter_count;
					this.loading = false;
					if (this.resetPages) {
						this.page = 1;
						this.resetPages = false;
					}
					// this.reloadApelidos()
					//this.concatTags();
					//window.console.log(this.items);
				},
				(err) => {
					window.console.log(err);
				}
			);
		},
		loadFeaturedImage() {
			let noticiasDestaqueLength = this.noticiasDestaque.length;
			this.noticiasDestaque.forEach((p, i) => {
				if (p.imagem.id != null) {
					this.$http({
						url: 'assets/' + p.imagem.id,
						responseType: 'blob',
					}).then((response) => {
						let reader = new FileReader();
						reader.readAsDataURL(response.data);
						reader.onload = () => {
							this.imgs[p.imagem.id] = reader.result;
							i + 1 === noticiasDestaqueLength ? this.$forceUpdate() : '';
						};
					});
				}
			});
		},
		requireImg(img) {
			return require('../assets/' + img);
		},
		concatTags() {
			this.items.forEach((el) => {
				if (el.tags != null) {
					this.allTags.push(...el.tags);
				}
			});

			this.allTags = this.allTags.filter((item, index) => {
				return this.allTags.indexOf(item) == index;
			});
		},

		sanitizeTitle(title) {
			var slug = '';
			// Change to lower case
			var titleLower = title.toLowerCase();
			// Letter "e"
			slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
			// Letter "a"
			slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
			// Letter "o"
			slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
			// Letter "u"
			slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
			// Letter "d"
			slug = slug.replace(/đ/gi, 'd');
			// Trim the last whitespace
			slug = slug.replace(/\s*$/g, '');
			// Change whitespace to "-"
			slug = slug.replace(/\s+/g, '-');

			return encodeURIComponent(slug);
		},
		searchConteudoVadeMecum() {
			if (this.buscaVadeMecum === '') return;
			this.loadingSearch = true;
			this.$http
				.get(
					`items/conteudoleis/?search=${this.buscaVadeMecum
					}&limit=-1&filter[id_lei][_in]=${this.vademecumSeleceted.leis
						.map((e) => e.leis_id_lei.id_lei)
						.toString()}`
				)
				.then((res) => {
					let resultadoBusca = [];
					res.data.data.forEach((el) => {
						if (resultadoBusca[el.id_lei] === undefined)
							resultadoBusca[el.id_lei] = [];
						resultadoBusca[el.id_lei].push(el);
					});
					this.vademecumSeleceted.leis.forEach((lei) => {
						if (resultadoBusca[lei.leis_id_lei.id_lei] === undefined)
							resultadoBusca[lei.leis_id_lei.id_lei] = [];
						lei.retornoBusca = resultadoBusca[lei.leis_id_lei.id_lei];
					});
					this.loadingSearch = false;
					this.$forceUpdate();
				});
		},
		highlight(content, query) {
			if (!query) {
				return content;
			}
			return content.replace(new RegExp(query, 'gi'), (match) => {
				return '<span class="my-orange">' + match + '</span>';
			});
		},
		postNick(idLei, nick) {
			this.$http
				.post(`items/apelidos_leis`, {
					status: 'Publicado',
					lei: idLei,
					apelido: nick,
				})
				.then((res) => {
					window.console.log(res);
					this.editNickVadeMecum = 0;
				});
		},

		criarApelido(lei) {
			this.editNickVadeMecum = lei.leis_id_lei.id_lei;
			this.novoApelido = '';
			// Focar no campo de input após um pequeno delay
			this.$nextTick(() => {
				const input = document.querySelector('input[placeholder="Digite o apelido"]');
				if (input) {
					input.focus();
				}
			});
		},

		salvarApelido(idLei, apelido) {
			if (apelido && apelido.trim() !== '') {
				this.postNick(idLei, apelido.trim());
			}
		},

		salvarNovoApelido(idLei) {
			if (this.novoApelido && this.novoApelido.trim() !== '') {
				this.postNick(idLei, this.novoApelido.trim());
				this.editNickVadeMecum = 0;
				this.novoApelido = '';
			} else {
				this.cancelarApelido();
			}
		},

		cancelarApelido() {
			this.editNickVadeMecum = 0;
			this.novoApelido = '';
		},

		addLeiToVade(lei, vadeMecum) {
			lei.loading = true;
			this.$http
				.patch('/items/vademecums/' + vadeMecum, {
					leis: {
						create: [
							{
								leis_id_lei: { id_lei: lei.id_lei },
								vademecums_id: vadeMecum,
							},
						],
					},
				})
				.then(() => {
					this.reloadVadeMecum(vadeMecum);
					lei.loading = false;

				});
			this.$http.get('/items/leis/' + lei.id_lei).then((res) => {
				if (res) {
					const newRanking = res.data.data.ranking_lei + 1;
					this.$http.patch('/items/leis/' + lei.id_lei, {
						ranking_lei: newRanking,
					});
				}
			});
		},
		addProjetoLeiToVade(projetoLei, vadeMecum) {
			projetoLei.loading = true;
			this.$http
				.patch('/items/vademecums/' + vadeMecum, {
					projetos_leis: {
						create: [
							{
								projetos_leis_id: { id: projetoLei.id },
								vademecums_id: vadeMecum,
							},
						],
					},
				})
				.then(() => {
					this.reloadVadeMecum(vadeMecum);
					projetoLei.loading = false;
				});
		},

		// Adicionando os métodos que estavam faltando
		getVadeMecumStatus(v) {
			switch (v.status) {
				case 'public':
					return 'Público';  // ← corrigido
				case 'published':
					return 'Privado';  // ← corrigido
				case 'private':
					return 'Privado';  // ← corrigido
				default:
					return 'Privado';
			}
		},

		formatDate(dateString) {
			if (!dateString) return '';
			const date = new Date(dateString);
			return date.toLocaleDateString('pt-BR');
		},

		createApelido() {
			// Implementar criação de apelido
		},

		updateVadeMecumVisibility() {
			// Implementar atualização de visibilidade
			// console.log('Atualizar visibilidade:', this.vademecumSeleceted.status);
		},
	},

	computed: {
		filteredLeisInVade() {
			const q = (this.buscaVadeMecum || '').trim().toLowerCase();
			if (!q) return this.vademecumSeleceted.leis || [];
			return (this.vademecumSeleceted.leis || []).filter((rel) => {
				const l = rel && rel.leis_id_lei ? rel.leis_id_lei : {};
				const numero = (l.numero_lei || '').toString().toLowerCase();
				const nome = (l.nome_lei || '').toLowerCase();
				return numero.includes(q) || nome.includes(q);
			});
		},
		filteredProjetosInVade() {
			const q = (this.buscaVadeMecum || '').trim().toLowerCase();
			if (!q) return this.vademecumSeleceted.projetos_leis || [];
			return (this.vademecumSeleceted.projetos_leis || []).filter((rel) => {
				const p = rel && rel.projetos_leis_id ? rel.projetos_leis_id : {};
				const numero = (p.numero || '').toString().toLowerCase();
				const nome = (p.nome || '').toLowerCase();
				const autor = (p.autor || '').toLowerCase();
				return numero.includes(q) || nome.includes(q) || autor.includes(q);
			});
		},
		isVademecumPublic: {
			get() {
				// CORREÇÃO: published = público (conforme seu backend)
				return this.vademecumSeleceted.status === 'public';
			},
			set(value) {
				// Switch ligado = 'published' (público)
				// Switch desligado = 'private' (privado)  
				const newStatus = value ? 'public' : 'private';
				this.updateVadeMecumStatus(newStatus);
			}
		},
		user() {
			return this.$store.state.user;
		},
		qtdePage() {
			return Math.ceil(
				this.totalFiltrado / this.perPage[this.perPageSelected]
			);
		},
		paginatedItems() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const end = start + this.itemsPerPage;
			return this.internalLeisSearch.slice(start, end);
		},
		totalPages() {
			return Math.ceil(this.totalItems / this.itemsPerPage);
		},
		intBreakPoint() {
			switch (this.$vuetify.breakpoint.name) {
				case 'xs':
					return 0;
				case 'sm':
					return 1;
				case 'md':
					return 2;
				case 'lg':
					return 3;
				case 'xl':
					return 4;
				default:
					return 0;
			}
		},
	},
	watch: {
		'$route.params.strFiltro': {
			handler: function (search) {
				if (search) {
					this.searchNoticia = search;
					this.reloadLeis();
				}
			},
			deep: true,
			immediate: true,
		},
		showDialogAddLeiToVade(oldValue, newValue) {
			if (newValue == false) {
				// this.clearInternalSearch();
			}
		},
		page(oldValue, newValue) {
			if (oldValue != newValue) {
				this.reloadLeis();
			}
		},
		perPageSelected() {
			this.reloadLeis();
		},
		filterTags: {
			handler() {
				this.reloadLeis();
			},
			deep: true,
		},
		searchNoticia(newValue) {
			if (newValue === null) {
				this.buscou = false;
				this.reloadLeis();
			}
		},
	},
};
</script>
